module.exports = __webpack_public_path__ + "static/media/searchIcon.d0a0f4a0.svg";